import { useEffect, useMemo, useState } from 'react';
import getFactoryList from '../../api/cars/getFactoryList';
import { CAR_ORIGIN_TYPES, CAR_ORIGIN_LABELS } from '../../constants/carOrigin';

// "Новое авто, произведённое в Казахстане" на деле не единый вариант из
// origin_car_list, а комбинация origin=NEW_KZ + конкретный завод (Cars.factoryId,
// отдельная таблица Factory) — то же самое, что собирает форма создания авто
// (pages/Car/NewCar/CarCreate.jsx). Подставляем список заводов вместо базового
// NEW_KZ, как и там, чтобы при ручной правке импорта можно было выбрать
// конкретный завод, а не только "Новое авто, произведённое в Казахстане" без
// уточнения
export const decomposeOrigin = (option) => {
  if (!option) return { originCarId: 0, factoryId: null };
  if (typeof option.value === 'string' && option.value.startsWith('factory_')) {
    return { originCarId: CAR_ORIGIN_TYPES.NEW_KZ, factoryId: option.factoryId };
  }
  return { originCarId: option.value, factoryId: null };
};

// Вариант списка по происхождению, распознанному бэком в файле (обратное к decomposeOrigin);
// null — в файле его не было
export const originOptionFor = (options, originCarId, factoryId) => {
  if (!originCarId) return null;
  if (factoryId) return options.find((o) => o.factoryId === factoryId) || null;
  return options.find((o) => o.value === originCarId) || null;
};

const useOriginOptions = () => {
  const [factoryList, setFactoryList] = useState([]);

  useEffect(() => {
    getFactoryList()
      .then((res) => setFactoryList(res?.data?.data || []))
      .catch(() => {});
  }, []);

  // Мемоизируем — без этого хук отдавал новый массив на каждый рендер, из-за
  // чего у любого потребителя (например React.memo-строк в
  // StockPendingRowsTable) ссылка на options менялась всегда, даже когда
  // список факультативно не менялся
  return useMemo(() => {
    const baseOptions = Object.keys(CAR_ORIGIN_TYPES)
      .filter((key) => CAR_ORIGIN_TYPES[key] !== CAR_ORIGIN_TYPES.NEW_KZ)
      .map((key) => ({
        value: CAR_ORIGIN_TYPES[key],
        label: CAR_ORIGIN_LABELS[CAR_ORIGIN_TYPES[key]],
      }));

    if (factoryList.length > 0) {
      const factoryOptions = factoryList.map((factory) => ({
        value: `factory_${factory.id}`,
        label: 'Новое авто, ' + factory.name,
        factoryId: factory.id,
      }));
      return [...factoryOptions, ...baseOptions];
    }

    return [
      { value: CAR_ORIGIN_TYPES.NEW_KZ, label: CAR_ORIGIN_LABELS[CAR_ORIGIN_TYPES.NEW_KZ] },
      ...baseOptions,
    ];
  }, [factoryList]);
};

export default useOriginOptions;
